export const LOCAL_STORAGE_KEY = {
  AUTO_LOGIN: 'AUTO_LOGIN',
  USER_INFO: 'USER_INFO',
} as const;
